
export default ({ request }) => ({
  get_biao_xing_records(params) {
    return request({
      url: '/platform/v1/biao_xing_records/list',
      method: 'get',
      params: params
    })
  },
  getBiaoXingChartData(params) {
    return request({
      url: '/platform/v1/biao_xing_records/chart_data',
      method: 'get',
      params: params
    })
  },
  putBiaoXingRecord(id, data) {
    return request({
      url: `/platform/v1/biao_xing_records/${id}`,
      method: 'put',
      params: { id },
      data: data
    })
  },
  post_biao_xing_records(data) {
    return request({
      url: '/platform/v1/biao_xing_records',
      method: 'post',
      data: data
    })
  },
  delete_biao_xing_record(id) {
    return request({
      url: `/platform/v1/biao_xing_records/${id}`,
      method: 'delete',
      params: { id }
    })
  }
})
